<template>
  <section id="about">
    <navigation class="absolute"></navigation>
    <hero :words="words" :subtitle="subtitle" :separator="false"></hero>
    <bacon title="About Me"></bacon>
    <div class="description" v-html="description">
    </div>
    <div class="icons">
      <span v-for="icon, index in icons">
        <div class="icon">
          <img :src="'/dist/' + icon.url"/>
          <p>{{icon.text}}</p>
        </div>
        <div v-if="index != icons.length - 1" class="separator"></div>
      </span>
    </div>
    <bacon title="Work With Me"></bacon>
    <ul class="services">
      <li v-for="service in services">{{service}}</li>
    </ul>

    <a href="https://drive.google.com/file/d/0B0uj_BDfRuwvcTg2NHJhMkxYbW8/view"
       target="_blank" class="button">Resume</a>

  </section>
</template>

<script>
  import Navigation from '../components/navigation.vue';
  import Hero from '../components/hero.vue';
  import Bacon from '../components/bacon.vue';

  require.context('../../assets/about-icons/', true);

  export default {
    components: {Navigation, Hero, Bacon},
    props: {
      id: String,
      name: String,
    },

    data () {
      return {
        words: ['Hello', 'Здраво', 'Hallo', 'مرحبا', 'Ciao', 'こんにちは', 'Bonjour'],
        subtitle: `Hi, I’m Nikoleta. I help companies around the world build amazing brands,
            packaging, websites and other services.`,
        description: `<p>I’m a passionate freelance print & web designer who specializes in
            creating clean and unique designs. I come from Serbia, but I currently reside
            in Chicago. I have Bachelor’s Degree in Graphic Design and a Master's Degree in
            Digital Communication and Media Arts.</p>
            <p>I’ve been working as a freelance Graphic Designer since 2012. I've worked on
            brands such as Dr. Josif Pancic, Bootleggers Coffee, Bebe Owl etc.
            I have in-house experience, with companies such as  NextMe and Digital Factory.
            This helped me become a team player, good listener and a diligent designer.
            On the other side, freelance projects gave me an amazing experience in communication
            and opportunities to work and learn from people from around the world.</p>
            <p>My biggest hobbies are traveling and meeting new people, learning about their culture,
            art and enjoying traditional cuisine. My dream job is to become a digital nomad,
            who will be able to work with as many people from different cultures as possible.
            I’m a very communicative person, I love art history, a good cup
            of coffee and long philosophical discussions with my friends.</p>`,
        icons: [
          {
            url: 'research_icon.png',
            text: 'Research'
          }, {
            url: 'brainstorm_icon.png',
            text: 'Brainstorm'
          }, {

            url: 'coffee_icon.png',
            text: 'Coffee'
          }, {
            url: 'idea_icon.png',
            text: 'Idea'
          }, {
            url: 'design_work_icon.png',
            text: 'Design'
          }
        ],
        services: ['Branding', 'Packaging Design ', ' Corporate Identity',
          'Website Design', 'UI', 'UX', 'Digital Design', 'Social Media']
      }
    },
  }
</script>

<style lang="scss">
  @import "../../css/main.scss";
  @import "../../css/about.scss";
</style>


// WEBPACK FOOTER //
// about.vue?d6a4500c